// extracted by mini-css-extract-plugin
module.exports = {"success-container":"src-components-reset-password-___reset-password__success-container___29xbi","emoji":"src-components-reset-password-___reset-password__emoji___2q2IK"};